// store/modules/notification.js
import { getNotification } from '@/api/config'

const state = {
    notifications: [],
    loading: false
}

const mutations = {
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications
    },
    SET_LOADING(state, status) {
        state.loading = status
    }
}

const actions = {
    async fetchNotifications({ commit }) {
        commit('SET_LOADING', true)
        try {
            const response = await getNotification()
            commit('SET_NOTIFICATIONS', response.data)
            return response.data
        } catch (error) {
            console.error('获取通知失败:', error)
            return []
        } finally {
            commit('SET_LOADING', false)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}